import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR} from '../theme.js';

export function getStaticPagesConfig() {
    return {
        custom: {
            [PALETTE_IDS.STATIC_PAGES]: {
                BadRoutePageView: {
                    container: {
                        style: {
                            height: '100%',
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.NATIVE_HOSTING_PAGE]: {
                NATIVE_HOSTING_PAGE_BG: COLOR.BRAND.BACKGROUND1,
                NATIVE_HOSTING_PAGE_HEADER_CLIENT_NAME_TEXT: COLOR.BRAND.BACKGROUND6,
                NATIVE_HOSTING_PAGE_STEP_INDEX_TEXT: COLOR.BRAND.FOREGROUND5,
                NATIVE_HOSTING_PAGE_STEP_INDEX_BG: COLOR.BRAND.BACKGROUND5,
            },
            [PALETTE_IDS.BAD_ROUTE_PAGE]: {
                BAD_ROUTE_PAGE_BG: COLOR.BRAND.BACKGROUND5,
                BAD_ROUTE_PAGE_TITLE_TEXT: COLOR.BRAND.FOREGROUND5,
                BAD_ROUTE_PAGE_INFO_TEXT: COLOR.BRAND.FOREGROUND5,
            },
        },
    };
}
